"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactApollo = require("react-apollo");
var _validateAddress = require("../utils/validateAddress");
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _p, _Fragment;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AddressValidator = function AddressValidator(props) {
  var value = props.value,
    errorMessages = props.errorMessages;
  var _useState = (0, _react.useState)(value || ""),
    address = _useState[0],
    setAddress = _useState[1];
  var _useState2 = (0, _react.useState)(errorMessages || ""),
    errorMsg = _useState2[0],
    setErrorMsg = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    verifiedAddress = _useState3[0],
    setVerifiedAddress = _useState3[1];
  var _useState4 = (0, _react.useState)(null),
    typingTimeout = _useState4[0],
    setTypingTimeout = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    isValidating = _useState5[0],
    setIsValidating = _useState5[1];
  var _useLazyQuery = (0, _reactApollo.useLazyQuery)(_validateAddress.VALIDATE_ADDRESS),
    validateAddress = _useLazyQuery[0],
    _useLazyQuery$ = _useLazyQuery[1],
    data = _useLazyQuery$.data,
    error = _useLazyQuery$.error;

  // Notify parent of validation state changes
  var notifyParentOfValidationState = function notifyParentOfValidationState(isValid) {
    var onChange = props.onChange,
      identify = props.identify,
      fieldName = props.fieldName;
    if (onChange) {
      // Pass a special flag to indicate this is a validation state update
      onChange(identify, fieldName, address, true, isValid);
    }
  };
  (0, _react.useEffect)(function () {
    if (data && data.getValidAddress) {
      var onChange = props.onChange,
        identify = props.identify,
        _fieldName = props.fieldName;

      // Clear loading state
      setIsValidating(false);
      if (data.getValidAddress.isValidAddress) {
        setVerifiedAddress(true);
        setErrorMsg("");

        // Update parent with validated address data
        if (onChange) {
          onChange(identify, _fieldName, address);
        }

        // Notify parent of validation success
        notifyParentOfValidationState(true);
      } else {
        setVerifiedAddress(false);
        setErrorMsg("Please add a valid Address");
        notifyParentOfValidationState(false);
      }
    }
  }, [data, address]);

  // Handle GraphQL errors
  (0, _react.useEffect)(function () {
    if (error) {
      setIsValidating(false);
      setVerifiedAddress(false);
      setErrorMsg("Address validation failed. Please try again.");
      notifyParentOfValidationState(false);
    }
  }, [error]);
  var validateGoogleAddress = function validateGoogleAddress() {
    var market = props.market,
      defaultLang = props.defaultLang,
      path = props.path;

    // Set loading state
    setIsValidating(true);

    // Just trigger the GraphQL query - don't check data immediately
    validateAddress({
      variables: {
        requestOptions: address,
        market: market,
        lang: defaultLang,
        path: path
      }
    });

    // Don't set validation state here - let useEffect handle it after query completes
    // This prevents the premature "invalid" state
  };

  // Debounced validation on typing
  var handleAddressChange = function handleAddressChange(e) {
    var addr = e.target.value;
    setAddress(addr);

    // Reset error while typing
    setErrorMsg("");

    // Clear previous timeout if still typing
    if (typingTimeout) clearTimeout(typingTimeout);

    // If input is too short, show error
    if (addr.length < 10) {
      setVerifiedAddress(false);
      setErrorMsg("Address must be at least 10 characters.");
      notifyParentOfValidationState(false);
      return;
    }

    // Debounce validation (e.g., 500ms after last keystroke)
    setTypingTimeout(setTimeout(function () {
      // Clear any existing error messages when starting validation
      setErrorMsg("");
      // Don't set verifiedAddress here - let the validation result determine it
      validateGoogleAddress();
    }, 500));
  };

  // Validation on blur
  var handleBlur = function handleBlur(e) {
    var onBlur = props.onBlur;
    if (address.length < 10) {
      setErrorMsg("Address must be at least 10 characters.");
      setVerifiedAddress(false);
      notifyParentOfValidationState(false);
      return;
    }
    // Don't set verifiedAddress here - let the validation result determine it
    validateGoogleAddress();
    setErrorMsg("");
    if (onBlur) onBlur(e);
  };
  var ref = props.ref,
    className = props.className,
    fieldName = props.fieldName,
    theme = props.theme,
    readOnly = props.readOnly,
    disabled = props.disabled,
    id = props.id,
    type = props.type,
    required = props.required,
    ariaDescribedBy = props.ariaDescribedBy,
    onFocus = props.onFocus;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    ref: ref,
    className: className,
    name: fieldName,
    readOnly: readOnly,
    disabled: disabled,
    id: id,
    type: type,
    value: address,
    required: required,
    "aria-describedby": ariaDescribedBy,
    onChange: handleAddressChange,
    onBlur: handleBlur,
    onFocus: onFocus
  }), !verifiedAddress && !isValidating && errorMsg.length > 0 ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
    message: errorMsg,
    theme: theme,
    role: "alert"
  }) : isValidating ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _constructedForm["default"].loading
  }, _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null, "Validating address..."))) : _Fragment || (_Fragment = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)));
};

//how fix Do not nest ternary expressions
var _default = AddressValidator;
exports["default"] = _default;